import { j as r } from "./index58.mjs";
import { RichText as t } from "./index26.mjs";
const a = (e) => /* @__PURE__ */ r.jsx(
  t,
  {
    readOnly: !0,
    className: "bg-transparent border-none -m-2",
    classNames: { toolbar: "hidden" },
    ...e,
    onChange: () => {
    }
  }
);
export {
  a as RichTextReadOnly
};
